export default {
  // https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions.scrollwheel
  // gestureHandling: 'cooperative',
  /* fullscreenControlOptions: {
    position: 'TOP_CENTER'
  }, */
  // disableDefaultUI:true,
  styles: [
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.business',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.business',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ],
};
